import { Component, Input } from '@angular/core';

@Component({
  selector: 'work-ui-progressbar',
  standalone: true,
  imports: [],
  templateUrl: './progressbar.component.html',
  styleUrl: './progressbar.component.scss',
})
export class ProgressbarComponent {
  @Input() min = 0;
  @Input() progress = 0;
  @Input() max = 100;

  get progressPercentage(): number {
    return ((this.progress - this.min) / (this.max - this.min)) * 100;
  }
}
